import { computed, defineComponent, h, ref, VNode } from "vue";

export const UiColumn = defineComponent({
  name: "Column",
  props: { field: String, header: String, sortable: Boolean },
  setup() {
    return () => null;
  },
});

function getColumns(nodes: VNode[] = []) {
  return nodes.filter((node) => (node.type as any)?.name === "Column");
}

export const UiDataTable = defineComponent({
  name: "DataTable",
  props: {
    value: { type: Array, default: () => [] },
    filters: Object,
    rows: { type: Number, default: 10 },
    paginator: Boolean,
    loading: Boolean,
  },
  setup(props, { slots }) {
    const sortField = ref("");
    const sortDir = ref<1 | -1>(1);
    const rows = computed(() => {
      const term = String(
        (props.filters as any)?.global?.value || "",
      ).toLowerCase();
      let data = [...(props.value as any[])];
      if (term)
        data = data.filter((item) =>
          JSON.stringify(item).toLowerCase().includes(term),
        );
      if (sortField.value) {
        data.sort(
          (a, b) =>
            String(a?.[sortField.value] ?? "").localeCompare(
              String(b?.[sortField.value] ?? ""),
            ) * sortDir.value,
        );
      }
      return props.paginator ? data.slice(0, props.rows) : data;
    });

    return () => {
      const columns = getColumns(slots.default?.() as VNode[]);
      return h(
        "div",
        {
          class:
            "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_10px_26px_rgba(15,23,42,0.05)]",
        },
        [
          slots.header
            ? h(
                "div",
                { class: "border-b border-slate-200 bg-slate-50/80 p-4" },
                slots.header(),
              )
            : null,
          props.loading
            ? h(
                "div",
                { class: "p-4 text-sm font-semibold text-slate-500" },
                "Đang tải dữ liệu...",
              )
            : null,
          h("div", { class: "overflow-x-auto" }, [
            h(
              "table",
              { class: "min-w-full divide-y divide-slate-200 text-sm" },
              [
                h(
                  "thead",
                  {
                    class:
                      "bg-slate-100 text-left text-sm font-bold uppercase text-slate-600",
                  },
                  h(
                    "tr",
                    columns.map((column) => {
                      const header = (column.children as any)?.header;
                      return h(
                        "th",
                        {
                          class: "whitespace-nowrap px-4 py-3.5",
                          onClick: () => {
                            const field = (column.props as any)?.field;
                            if (!field) return;
                            sortDir.value =
                              sortField.value === field
                                ? ((sortDir.value * -1) as 1 | -1)
                                : 1;
                            sortField.value = field;
                          },
                        },
                        header
                          ? header({})
                          : (column.props as any)?.header || "",
                      );
                    }),
                  ),
                ),
                h(
                  "tbody",
                  { class: "divide-y divide-slate-100 bg-white" },
                  rows.value.map((row) =>
                    h(
                      "tr",
                      { class: "transition hover:bg-teal-50/45" },
                      columns.map((column) => {
                        const props = column.props as any;
                        const body = (column.children as any)?.body;
                        return h(
                          "td",
                          {
                            class: "px-4 py-3.5 text-[12px] text-slate-700",
                          },
                          body
                            ? body({ data: row })
                            : row?.[props?.field] ?? "",
                        );
                      }),
                    ),
                  ),
                ),
              ],
            ),
          ]),
        ],
      );
    };
  },
});

export const UiDataView = defineComponent({
  name: "DataView",
  props: {
    value: { type: Array, default: () => [] },
    rows: { type: Number, default: 20 },
    paginator: Boolean,
  },
  setup(props, { slots }) {
    return () =>
      h(
        "div",
        { class: "grid grid-cols-[repeat(auto-fill,minmax(150px,1fr))] gap-4" },
        (props.value as any[])
          .slice(0, props.paginator ? props.rows : undefined)
          .map((data) =>
            h(
              "div",
              { class: "min-w-0" },
              (slots as any).grid
                ? (slots as any).grid({ data })
                : h("div", data),
            ),
          ),
      );
  },
});

export const UiBadge = defineComponent({
  name: "Badge",
  props: { value: [String, Number] },
  setup(props) {
    return () =>
      h(
        "span",
        {
          class:
            "inline-flex rounded-full bg-teal-100 px-2 py-1 text-xs font-bold text-teal-800",
        },
        props.value,
      );
  },
});

export const UiChart = defineComponent({
  name: "Chart",
  setup: () => () => h("div"),
});
export const UiGalleria = defineComponent({
  name: "Galleria",
  setup:
    (_, { slots }) =>
    () =>
      h("div", slots.default?.()),
});
